import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { CheckCircle2, Check, FileText, Award, Users, Lightbulb, ArrowRight } from "lucide-react";
import { RenderIf } from "./render-if";
type EligibilityCardProps = {
  courseName: string;
  isHtmlDescription: boolean;
  description: string;
  list?: {
    seoHeading?: string;
    heading: string;
    description: string;
  }[];
  onAction?: () => void;
};
export const EligibilityCard = t0 => {
  const $ = _c(39);
  const {
    isHtmlDescription,
    description,
    list,
    courseName,
    onAction
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pointer-events-none absolute -top-30 -right-25 h-70 w-70 rounded-full bg-[#f0f6fc] dark:bg-blue-900/10" />;
    t2 = <div className="pointer-events-none absolute -top-25 -right-20 h-50 w-50 rounded-full bg-[#e1effa] dark:bg-blue-900/20" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-primary/70 text-xs font-bold tracking-[0.15em] uppercase dark:text-blue-400">Eligibility</p>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== courseName) {
    t4 = <CardTitle className="text-primary text-xl font-extrabold dark:text-white">Am I Eligible for {courseName}?</CardTitle>;
    $[3] = courseName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-muted-foreground text-xs dark:text-slate-400">Quick answer, so you can get started with confidence.</p>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <CardHeader className="relative z-10 space-y-2 pt-2 pb-6">{t3}{t4}{t5}</CardHeader>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== list) {
    t7 = list?.map(_temp);
    $[8] = list;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <div>{t7}</div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== description) {
    t9 = <div dangerouslySetInnerHTML={{
      __html: description
    }} className="typeset" />;
    $[12] = description;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isHtmlDescription || $[15] !== t8 || $[16] !== t9) {
    t10 = <RenderIf condition={isHtmlDescription} fallback={t8}>{t9}</RenderIf>;
    $[14] = isHtmlDescription;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = !description && !list?.length;
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-4 rounded-xl bg-emerald-50 p-4 dark:bg-emerald-950"><div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white"><Check className="h-6 w-6 stroke-3" /></div><p className="text-base font-bold text-slate-800 dark:text-slate-200">Yes — this course is open to all.</p></div>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-400"><FileText className="h-6 w-6" /></div>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex items-start gap-4">{t13}<div className="flex flex-col"><span className="font-bold text-slate-800 dark:text-slate-200">No formal prerequisites</span><span className="text-sm text-slate-500 dark:text-slate-400">{"You don't need prior coursework."}</span></div></div>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-400"><Award className="h-6 w-6" /></div>;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex items-start gap-4">{t15}<div className="flex flex-col"><span className="font-bold text-slate-800 dark:text-slate-200">No previous certification required</span><span className="text-sm text-slate-500 dark:text-slate-400">{"Everyone is welcome."}</span></div></div>;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-400"><Users className="h-6 w-6" /></div>;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="space-y-5">{t14}{t16}<div className="flex items-start gap-4">{t17}<div className="flex flex-col"><span className="font-bold text-slate-800 dark:text-slate-200">Recommended for all learner levels</span><span className="text-sm text-slate-500 dark:text-slate-400">{"Whether you're a beginner or experienced, this course is for\n                    you."}</span></div></div></div>;
    t19 = <hr className="border-slate-200 dark:border-slate-800" />;
    $[24] = t18;
    $[25] = t19;
  } else {
    t18 = $[24];
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex flex-col space-y-6">{t12}{t18}{t19}<div className="flex items-center justify-center gap-2 pb-2 text-slate-500 dark:text-slate-400"><Lightbulb className="h-5 w-5 text-blue-500 dark:text-blue-400" /><span className="text-sm italic">Just bring your interest to learn.</span></div></div>;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t11) {
    t21 = <RenderIf condition={t11}>{t20}</RenderIf>;
    $[27] = t11;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ArrowRight className="ml-2 h-5 w-5" />;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== onAction) {
    t23 = <div><Button className="w-full text-base font-semibold text-white" onClick={onAction} size="lg">Explore Course Details {t22}</Button></div>;
    $[30] = onAction;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t10 || $[33] !== t21 || $[34] !== t23) {
    t24 = <CardContent className="relative z-10 space-y-3">{t10}{t21}{t23}</CardContent>;
    $[32] = t10;
    $[33] = t21;
    $[34] = t23;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== t24 || $[37] !== t6) {
    t25 = <Card className="dark:bg-card relative w-full max-w-sm gap-0 overflow-hidden bg-white shadow-sm">{t1}{t2}{t6}{t24}</Card>;
    $[36] = t24;
    $[37] = t6;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  return t25;
};
function _temp(item, index) {
  return <div className="flex items-start gap-4" key={`eligibility-item-${index}`}><CheckCircle2 className="text-primary mt-0.5 h-6 w-6 shrink-0" /><div className="flex flex-col"><span className="text-sm font-semibold">{item.heading}</span><span className="text-muted-foreground mt-1 text-sm">{item.description}</span></div></div>;
}